export async function generateFingerPrint() {
  // await waitForPageLoad;
  // const fp = await FingerprintJS.load();
  // const result = await fp.get();
  // const visitorId = hashComponents(result);
  return btoa('vendor-fingerprint');
}
